<template>
    <div class="width100">
        <vue-confirm-dialog></vue-confirm-dialog>

        <Aide v-bind:token="token" v-bind:site="site" v-bind:racine="racine"
              v-bind:user="user" v-bind:idAide="11"></Aide>

        <h3 class="titreSolu text-center">Lavage</h3>


        <div v-if="errors.length" class="alert alert-danger text-center" role="alert">
            <p v-for="(error, key) in errors" :key="key">{{ error }}</p>
        </div>
        <div v-if="msgs.length" class="alert alert-success text-center" role="alert">
            <p v-for="(msg, key) in msgs" :key="key">{{ msg }}</p>
        </div>

        <h3 class="titreSolu text-center" v-if="niveau==1">De quelle remorque il s'agit ?</h3>
        <p class="text-center text-warning" v-if="niveau==1">Cette liste est classée par votre fréquence d'utilisation.</p>
        <div v-if="niveau == 1" class="row" style="overflow: scroll;height:250px;">
            <div v-for="(remorque, keyRem) in listRemorque" :key="keyRem" class="colSolu col-md-12 col-lg-4">
                <div class="thtab userList col-12 text-center rounded"
                     @click="choixMachine(remorque)">
                    {{remorque.numero}}
                </div>
            </div>
        </div>

        <div v-if="niveau == 2">
            <div v-if="idUserLingevres>0">


                <div>
                    <div class="row">
                        <div class="col-6">
                            Date
                        </div>
                        <div class="col-6">
                            <input type="date" class="form-control" @change="getLavageByDate()" v-model="date">
                        </div>
                    </div>
                    <br/>
                    <div class="row">
                        <div class="col-6">
                            Véhicule
                        </div>
                        <div class="col-6">
                            {{vehiculeNom}}
                        </div>
                    </div>
                    <br/>
                    <div class="row">
                        <div class="col-4">
                            Lavage intérieur
                        </div>
                        <div class="col-4">
                            <span v-if="lastInt!=null" class="text-success">Dernière fois {{lastInt}}</span>
                        </div>
                        <div class="col-4 text-center">
                            <input type="checkbox" v-model="lavageI" value="1">
                        </div>
                    </div>
                    <br/>
                    <div class="row">
                        <div class="col-4">
                            Lavage extérieur
                        </div>
                        <div class="col-4">
                            <span v-if="lastExt!=null" class="text-success">Dernière fois {{lastExt}}</span>
                        </div>
                        <div class="col-4 text-center">
                            <input type="checkbox" v-model="lavageE" value="1">
                        </div>
                    </div>
                    <br/>
                    <div class="row">
                        <div class="col-4">
                            Désinfection
                        </div>
                        <div class="col-4">
                            <span v-if="lastDesinf!=null" class="text-success">Dernière fois {{lastDesinf}}</span>
                        </div>
                        <div class="col-4 text-center">
                            <input type="checkbox" v-model="desinfection" value="1">
                        </div>
                    </div>
                    <br/>
                </div>
                <br/>
                <div class="row">
                    <div v-if="show" class="alert alert-info" role="alert">
                        Vous ne pouvez plus modifier cette ligne
                    </div>
                    <div class="col-12 text-center">
                        <button @click="save" v-if="idLavage==null && show==null" class="btn btn-primary">Enregistrer
                        </button>
                        <button @click="save" v-if="idLavage!=null" class="btn btn-primary">Modifier</button>
                        &nbsp;
                        <button @click="videDeclaration(1)" class="btn btn-warning">Annuler</button>
                        &nbsp;
                        <button @click="deleteDeclaration" v-if="idLavage!=null" class="btn btn-danger">Supprimer
                        </button>

                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-12 text-center">
                        <table v-if="listLavageByDate.length" class="table table-striped table-hover table-bordered"
                               cellspacing="0" cellpadding="0">
                            <tr>
                                <th class="thtab">Date</th>
                                <th class="thtab">Int</th>
                                <th class="thtab">Ext</th>
                                <th class="thtab">Désinf</th>
                            </tr>
                            <tr v-for="(lavage, key) in listLavageByDate" :key="key" @click="openUpdate(lavage)">
                                <td v-bind:class="{ thtabOrange: showColor==lavage.id }">{{afficheDateFr(lavage.date)}}
                                    ({{lavage.remorque.numero}})
                                </td>
                                <td v-bind:class="{ thtabOrange: showColor==lavage.id }">
                                    <i v-if="lavage.interieur==1" class="fa-solid text-success fa-check fa-2x"></i>
                                    <i v-else class="fa-solid text-danger fa-xmark fa-2x"></i>
                                </td>
                                <td v-bind:class="{ thtabOrange: showColor==lavage.id }">
                                    <i v-if="lavage.exterieur==1" class="fa-solid text-success fa-check fa-2x"></i>
                                    <i v-else class="fa-solid text-danger fa-xmark fa-2x"></i>
                                </td>
                                <td v-bind:class="{ thtabOrange: showColor==lavage.id }">
                                    <i v-if="lavage.desinfection==1" class="fa-solid fa-2x text-success fa-check"></i>
                                    <i v-else class="fa-solid fa-2x text-danger fa-xmark"></i>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div v-if="errors.length" class="alert alert-danger text-center" role="alert">
                    <p v-for="(error, key) in errors" :key="key">{{ error }}</p>
                </div>
                <div v-if="msgs.length" class="alert alert-success text-center" role="alert">
                    <p v-for="(msg, key) in msgs" :key="key">{{ msg }}</p>
                </div>
            </div>
            <div v-else>
                <div class="alert alert-danger" role="alert">
                    Vous n'avez pas été trouvé dans la base de données de connexion. Merci de vous rapprocher de votre
                    responsable.
                </div>
            </div>
        </div>
        <div v-else  class="col-12 text-center">
            <button @click="returnNiveau" v-if="niveau!=1" class="btn btn-warning">Annuler</button>
        </div>
    </div>
</template>

<script>
    import Aide from './Aide';


    export default {
        name: "LavageRemorque",
        props: ['token', 'site', 'user', 'racine', 'userId', 'systemeClient', 'idUser'],
        data() {
            return {
                errors: [], msgs: [], date: null, vehicule: null, vehiculeNom: null, vehiculeType: null,
                idUserLingevres: 0, systemeIdLingevres: 1, afficheRemorque: 1,
                lavageE: 0, lavageI: 0, desinfection: 0, idLavage: null,
                remorque: null, listLavageByDate: [],
                listRemorque: [], dateToday: null, show: null, showColor: null,
                niveau: 1, machineType: null,
                lastDesinf:null,lastInt:null,lastExt:null,
            };
        },
        methods:
            {
                tokenValide(json) {
                    if (json['status'] == '401') {
                        this.$emit('token')
                    }
                },
                input(input) {
                    console.log(input)
                    this.vehicule = input
                },
                inputNom(input) {
                    console.log(input)
                    this.vehiculeNom = input
                },
                inputType(input) {
                    console.log(input)
                    this.vehiculeType = input
                },

                save() {

                    if (this.date != null && this.remorque != null) {
                        var today = new Date()
                        if(this.afficheDateUs(today) >= this.date) {//si pas date future


                            var lavageInt = 0
                            if (this.lavageI == true) {
                                lavageInt = 1
                            }
                            var lavageExt = 0
                            if (this.lavageE == true) {
                                lavageExt = 1
                            }
                            var desinf = 0
                            if (this.desinfection == true) {
                                desinf = 1
                            }
                            console.log(this.lavageI)
                            console.log(this.lavageE)
                            console.log(this.desinfection)

                            var msg = ""


                            if (this.idLavage != null) {
                                fetch(this.racine + this.site + 'api/lavage_vehicules/' + this.idLavage, {
                                    method: 'PUT',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': 'Bearer ' + this.token
                                    },
                                    body: "{\"date\":\"" + this.date + "\"," +
                                    "\"id\": " + this.idLavage + "," +
                                    "\"desinfection\": " + desinf + "," +
                                    "\"interieur\": " + lavageInt + "," +
                                    "\"exterieur\": " + lavageExt + "," +
                                    "\"remorque\": \"" + this.remorque + "\"," +
                                    "\"userId\": " + this.idUserLingevres + "," +
                                    "\"systemeClient\": " + this.systemeIdLingevres + "," +
                                    "\"created\": \"" + this.dateToday + "\"" +
                                    "}"
                                }).then(response => response.json())
                                    .then(json => {
                                        console.log(json);
                                        if (json['@type'] == "hydra:Error") {
                                            this.errors = []
                                            this.msgs = []
                                            this.errors.push("Un problème inconnu s'est produit.")
                                        }
                                        else if (json['id'] > 0) {
                                            this.msgs = []
                                            this.msgs.push("Votre déclaration a bien été prise en compte.")
                                            this.videDeclaration(1)
                                            this.getLavageByDate()
                                        }
                                        else {
                                            this.errors = []
                                            this.msgs = []
                                            this.errors.push("Un problème inconnu s'est produit.")
                                        }
                                    })
                            }
                            else {

                                fetch(this.racine + this.site + 'api/lavage_vehicules', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': 'Bearer ' + this.token
                                    },
                                    body: "{\"date\":\"" + this.date + "\"," +
                                    "\"desinfection\": " + desinf + "," +
                                    "\"interieur\": " + lavageInt + "," +
                                    "\"exterieur\": " + lavageExt + "," +
                                    "\"remorque\": \"" + this.remorque + "\"," +
                                    "\"userId\": " + this.idUserLingevres + "," +
                                    "\"systemeClient\": " + this.systemeIdLingevres + "," +
                                    "\"created\": \"" + this.dateToday + "\"" +
                                    "}"
                                }).then(response => response.json())
                                    .then(json => {
                                        console.log(json);
                                        if (json['@type'] == "hydra:Error") {
                                            this.errors = []
                                            this.msgs = []
                                            this.errors.push("Un problème inconnu s'est produit.")
                                        }
                                        else if (json['id'] > 0) {
                                            this.msgs = []
                                            this.msgs.push("Votre déclaration a bien été prise en compte.")
                                            this.msgs.push(msg)
                                            console.log(msg)
                                            this.videDeclaration(1)
                                        }
                                        else {
                                            this.errors = []
                                            this.msgs = []
                                            this.errors.push("Un problème inconnu s'est produit.")
                                        }
                                    })
                            }

                        }
                        else {
                            this.errors.push("Vous ne pouvez pas saisir un lavage dans l'avenir.")
                        }
                    }
                    else {
                        this.errors.push("Vous devez remplir tous les champs pour enregistrer.")
                    }


                },
                getUserLingevres() {
                    fetch(this.racine + this.site + 'api/get_id_user_lingevres/' + this.idUser, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        this.tokenValide(response)
                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.idUserLingevres = json['idUserLingevres']
                                this.getListRemorque()
                            }
                        })
                    })
                },
                getLavageByDate() {
                    this.show = null
                    this.showColor = null
                    this.videDeclaration(2)
                    fetch(this.racine + this.site + 'api/lavage_vehicules?date=' + this.date + '&userId=' + this.idUserLingevres, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        this.tokenValide(response)
                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.listLavageByDate = json['hydra:member']
                            }
                        })
                    })
                },
                deleteDeclaration() {
                    if (this.idLavage != null) {
                        this.$bvModal.msgBoxConfirm('Etes vous sur de vouloir supprimer cette déclaration', {
                            title: 'Etes vous sûr?',
                            size: 'lg',
                            buttonSize: 'lg',
                            okVariant: 'danger',
                            okTitle: 'Oui',
                            cancelTitle: 'Non',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true,
                            noFade: true
                        })
                            .then(value => {
                                if (value == true) {
                                    console.log(value)
                                    fetch(this.racine + this.site + 'api/lavage_vehicules/' + this.idLavage, {
                                        method: 'DELETE',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'Authorization': 'Bearer ' + this.token
                                        },
                                    }).then(response => {
                                        this.tokenValide(response)
                                        console.log(response)
                                        if (response.ok == true) {
                                            this.msgs = []
                                            this.msgs.push("La suppression de votre déclaration du " + this.date + " a bien été réalisée.")
                                            this.videDeclaration(1)
                                            this.getLavageByDate()
                                        }
                                    })
                                }
                            })
                    }

                },
                videDeclaration(all) {
                    this.show = null
                    this.showColor = null
                    this.desinfection = null
                    this.lavageE = null
                    this.lavageI = null

                    this.idLavage = null
                    var self = this
                    if(all==1) {
                        this.vehiculeType = null
                        this.vehicule = null
                        this.vehiculeNom = null
                        this.returnNiveau()
                    }
                    if(all!=2) {
                        this.remorque = null
                    }
                    setTimeout(function () {
                        self.errors = []
                        self.msgs = []
                    }, 2000);
                },
                getListRemorque() {
                    fetch(this.racine + this.site + 'api/get_remorque_par_frequence_utilisation_conso_lavage/'+ this.idUserLingevres +'/'+ this.systemeIdLingevres, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        this.tokenValide(response)
                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.listRemorque = json['hydra:member']
                            }
                        })
                    })
                },
                afficheDateFr(dateBDD) {
                    var today = new Date(dateBDD)
                    var month = today.getMonth() + 1
                    var day = today.getDate()
                    if (month < 10) {
                        month = "0" + month
                    }
                    if (day < 10) {
                        day = "0" + day
                    }
                    return day + '/' + month + '/' + today.getFullYear()
                },
                afficheDateUs(dateBDD) {
                    var today = new Date(dateBDD)
                    var month = today.getMonth() + 1
                    var day = today.getDate()
                    if (month < 10) {
                        month = "0" + month
                    }
                    if (day < 10) {
                        day = "0" + day
                    }
                    return today.getFullYear() + '-' + month + '-' + day
                },
                openUpdate(lavage) {
                    console.log(lavage)
                    var hier = new Date()
                    hier.setDate(hier.getDate() - 1);
                    if (this.dateToday == this.afficheDateUs(lavage.created) || this.afficheDateUs(hier) == this.afficheDateUs(lavage.created)) {
                        this.idLavage = lavage.id
                        this.show = null
                    }
                    else {
                        this.show = lavage.id
                        this.idLavage = null
                    }
                    this.showColor = lavage.id
                    this.vehiculeType = lavage.remorque['@type']
                    this.vehicule = lavage.remorque['@id']
                    this.vehiculeNom = lavage.remorque['numero']
                    this.remorque = lavage.remorque['@id']


                    this.lavageI = lavage.interieur
                    this.lavageE = lavage.exterieur
                    this.desinfection = lavage.desinfection

                },
                choixMachine(vehicule) {
console.log(vehicule)
                    this.niveau = 2
                    this.remorque = null

                    this.vehiculeType = vehicule['@type']
                    this.vehicule = vehicule['@id']
                    this.vehiculeNom = vehicule['numero']
                    this.remorque = vehicule['@id']

                    this.lastDesinf = null
                    this.lastInt = null
                    this.lastExt = null

                    fetch(this.racine + this.site + 'api/get_last_lavage/'+vehicule['id']+'/'+this.vehiculeType, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        this.tokenValide(response)
                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                //this.listRemorque = json['hydra:member']
                                this.lastDesinf = json['desinf']
                                this.lastInt = json['int']
                                this.lastExt = json['ext']
                            }
                        })
                    })
                },
                returnNiveau()
                {
                    if(this.niveau>1)
                    {
                        this.niveau--
                    }
                }

            },
        mounted() {
            if (this.systemeClient == 1) {
                this.systemeIdLingevres = 2
            }
            else if (this.systemeClient == 2) {
                this.systemeIdLingevres = 1
            }
            this.getUserLingevres()

            var today = new Date()
            this.dateToday = this.afficheDateUs(today)

        },
        created() {
        },
        components: {
            Aide,
        }
    }
</script>

<style scoped>

</style>